import { useEffect, useRef, useState } from "react";

import { Tooltip } from "../Tooltip/Tooltip";

interface TruncatedCellProps {
  text: string;
}

const TruncatedCell = ({ text }: TruncatedCellProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setIsOverflowing(el.scrollWidth > el.clientWidth);
    const observer = new ResizeObserver(check);
    observer.observe(el);
    check();

    return () => observer.disconnect();
  }, []);

  return (
    <Tooltip content={isOverflowing ? text : undefined} classNames={{ wrapper: "min-w-0 flex-1" }}>
      <span className="block truncate" ref={ref}>
        {text}
      </span>
    </Tooltip>
  );
};

export { TruncatedCell };
